import { c as _c } from "react/compiler-runtime";
import Avatar from '@classify/react-core-components/Avatar';
interface Props {
  user: {
    displayName: string;
    id: string | number;
    profilePicture: string;
  };
  isSmaller: boolean;
}
export default function MemberAvatar(t0) {
  const $ = _c(5);
  const {
    isSmaller,
    user
  } = t0;
  const t1 = isSmaller ? "xs" : "s";
  let t2;
  if ($[0] !== t1 || $[1] !== user.displayName || $[2] !== user.id || $[3] !== user.profilePicture) {
    t2 = <Avatar userName={user.displayName} userId={user.id} src={user.profilePicture} size={t1} />;
    $[0] = t1;
    $[1] = user.displayName;
    $[2] = user.id;
    $[3] = user.profilePicture;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}